import * as Card from '@/components/ui/card'
import * as Dialog from '@/components/ui/dialog'
import { Text } from '@/components/ui/text'
import { AppCollapsible, FieldInformation } from '@components'
import { Show } from 'solid-js'
import { Box, Flex } from 'styled-system/jsx'

import { IconButton } from '@/components/ui/icon-button'
import { TradingViewWidget } from '@components/TradingViewWidget'
import { Maximize2 } from 'lucide-solid'
import { Portal } from 'solid-js/web'

export function Chart(props: { symbol?: string | null, exchange?: string | null }) {

  return (
    <Show when={props.symbol && props.exchange}>
      <Card.Root p={3}>
        <AppCollapsible hideBorder headerContent={
          <Flex alignItems='center' justifyContent='space-between' w='full' mr='1'>
            <FieldInformation information='Use this live chart to obtain up to date information of the HVF price and time points'>
              <Text>Live Chart</Text>
            </FieldInformation>

            <Dialog.Root size='cover'>
              <Dialog.Trigger
                asChild={(props) => (
                  <IconButton {...props} size='xs' variant='plain'>
                    <Maximize2 />
                  </IconButton>
                )}
              />
              <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner>
                  <Dialog.Content>
                    <Dialog.Header>
                      <Dialog.Title>{props.symbol}, {props.exchange}</Dialog.Title>
                    </Dialog.Header>
                    <Dialog.Body>
                      <Box w='full' h='full' overflow='hidden' borderRadius='l1'>
                        <TradingViewWidget
                          id="tv-widget-dialog-dialog"
                          exchange={props.exchange}
                          symbol={props.symbol}
                        />
                      </Box>
                    </Dialog.Body>
                  </Dialog.Content>
                </Dialog.Positioner>
              </Portal>
            </Dialog.Root>
          </Flex>

        }>
          <Box height={300} overflow='hidden' borderRadius='l1' mt='3'>
            <TradingViewWidget
              id="tv-widget-dialog-inline"
              exchange={props.exchange}
              symbol={props.symbol}
            />
          </Box>
        </AppCollapsible>
      </Card.Root>
    </Show>
  )
}
